export default "__VITE_ASSET__DtA7Jt8A__"